<!-- background image -->
<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<!-- black background overlay -->
<div class="absolute inset-0 bg-black/50"></div>

<!-- Profile selection -->
<div class="relative flex h-screen w-screen flex-col items-center justify-center gap-8">
  @if (loading()) {
    <div class="grid max-w-4xl place-items-center p-4">
      <svg class="size-32 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
    </div>
  } @else {
    <app-portal-class-profiles
      [profiles]="profiles()"
      (clickedProfile)="selectProfile($event.playerCode)"
      (clickedSwitchClass)="switchClass()"
    />
  }
</div>

<!-- Confirmation dialog for switching class -->
@if (showConfirmDialog()) {
  <div class="fadesIn absolute inset-0 z-50 flex items-center justify-center bg-black/80">
    <div class="h-[444px] w-[400px]">
      <app-portal-panel>
        <div class="flex h-full flex-col justify-between gap-2 px-4">
          <div class="flex flex-col gap-2">
            <div class="barlow-semi-condensed-bold text-4xl text-white">Weet je zeker dat je een andere klas wil importeren?</div>
            <div class="barlow-regular text-2xl text-white">Er is een maximum van één actieve klas per apparaat.</div>
          </div>
          <div class="flex flex-col gap-4">
            <div class="h-12 w-full">
              <app-portal-button color="blue" (click)="cancelSwitchClass()">
                <div class="barlow-semi-condensed-semibold text-2xl">Terug naar profielen</div>
              </app-portal-button>
            </div>
            <div class="h-12 w-full">
              <app-portal-button color="red" (click)="confirmSwitchClass()">
                <div class="barlow-semi-condensed-semibold my-2 text-2xl">Andere klas importeren</div>
              </app-portal-button>
            </div>
          </div>
        </div>
      </app-portal-panel>
    </div>
  </div>
}

<!-- Confirmation dialog for resetting app -->
@if (showResetConfirmDialog()) {
  <div class="fadesIn absolute inset-0 z-50 flex items-center justify-center bg-black/80">
    <div class="h-[444px] w-[400px]">
      <app-portal-panel>
        <div class="flex h-full flex-col justify-between gap-2 px-4">
          <div class="flex flex-col gap-2">
            <div class="barlow-semi-condensed-bold text-4xl text-white">Weet je zeker dat je de app wil resetten?</div>
            <div class="barlow-regular text-2xl text-white">Je moet de app daarna opnieuw activeren en profielen toevoegen.</div>
          </div>
          <div class="flex flex-col gap-4">
            <div class="h-12 w-full">
              <app-portal-button color="blue" (click)="cancelResetApp()">
                <div class="barlow-semi-condensed-semibold text-2xl">Terug naar profielen</div>
              </app-portal-button>
            </div>
            <div class="h-12 w-full">
              <app-portal-button color="red" (click)="confirmResetApp()">
                <div class="barlow-semi-condensed-semibold my-2 text-2xl">App resetten</div>
              </app-portal-button>
            </div>
          </div>
        </div>
      </app-portal-panel>
    </div>
  </div>
}

<!-- Reset app -->
<button class="barlow-regular absolute top-0 right-0 flex h-28 w-44 items-center justify-center text-xl text-white" (click)="resetApp()">
  Reset App
</button>
